import React, { Component } from 'react';

// Spinner icon

const Spinner = (props) => {
    return (
        < div className= "ball-pulse" style={props.style} >
            <div></div>
            <div></div>
            <div></div>
        </div >
    )
}

export default Spinner;


// WEBPACK FOOTER //
// ./master/jsx/components/Widgets/spinner.jsx